import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-single-blog-card',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './single-blog-card.component.html',
  styleUrl: './single-blog-card.component.scss',
})
export class SingleBlogCardComponent {
  @Input() item: any = [];
  @Input() showDescription: boolean = true;
  @Input() showViews = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {}

  navigateToBlog(slug: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.router.navigate([`blog/${slug}`]);
    }
  }
}
